import { InfoTip } from "#webapp/src/components/tool-tip";
import { useInterval } from "@clockwise/web-commons/src/hooks/useInterval";
import { DateTime, IANAZone } from "luxon";
import React from "react";

type Props = {
  /** IANA Zone (e.g. Americas/Los_Angeles) */
  zone: string;
  name: string;
  showTooltip?: boolean;
};

export function TimeWithTooltip({ zone, name, showTooltip = true }: Props) {
  const [currentTime, setCurrentTime] = React.useState(DateTime.now());
  useInterval(() => setCurrentTime(DateTime.now()), 60 * 1000);

  const timeZone = IANAZone.create(zone);
  const timeZoneCode = timeZone.offsetName(currentTime.toMillis(), { format: "short" });
  const time = currentTime.setZone(timeZone).toFormat("t ZZZZ");

  return (
    <span className="cw-flex cw-items-center">
      <span>{time}</span>
      {showTooltip && (
        <InfoTip
          text={
            <div className="cw-text-center">
              {name}'s primary work time zone
              <br />
              is {timeZone.name} ({timeZoneCode}).
            </div>
          }
          tipType="info"
        />
      )}
    </span>
  );
}
